import { defineView } from "@knyt/weaver";
import { defineComponent } from "./defineComponent/mod.js";
import { defineElement } from "./defineElement.js";
import { defineProperties } from "./defineProperties.js";
import { defineProperty } from "./defineProperty.js";
/**
 * A set of functions for defining custom elements and their properties.
 */
export const define = {
    /**
     * @deprecated This is an experimental API that WILL change without notice.
     */
    component: defineComponent,
    element: defineElement,
    /**
     * @deprecated This function is no longer needed and will be removed in the future.
     */
    // TODO: Remove this.
    properties: defineProperties,
    property: defineProperty,
    /**
     * Shorthand for `define.property()`.
     *
     * @see {@link defineProperty}
     */
    get prop() {
        return defineProperty();
    },
    view: defineView,
};
